<!--
component: ListEstate
author: Ken Nakamura
description: 建築計画概要書 同一物件検索結果リスト
-->
<template>
  <section>
    <v-data-table
      :headers="headers" :items="kenkaku"
      :fixed-header="false" height="calc(100vh - 20em)"
      mobile-breakpoint="0"
      disable-pagination hide-default-footer
      :single-select="true" item-key="daichoId"
      class="elevation-1"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items"
            @click="selectRow(item)"
            :key="index"
            :class="{selected:item.active}"
            class="default"
          >
            <td>{{item.ukeNo}}</td>
            <td>{{dateTextToWareki(item.ukeDay)}}</td>
            <td>{{item.kknnNo}}</td>
            <td>{{dateTextToWareki(item.kknnDay)}}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { dbglog, dateTextToWareki } from '../common/utils'

export default {
  data: () => {
    return {
      loading: false,
      headers: [
        {
          text: '受付番号',
          value: 'ukeNo'
        },
        {
          text: '受付日付',
          value: 'ukeDay'
        },
        {
          text: '処分番号',
          value: 'kknnNo'
        },
        {
          text: '処分日付',
          value: 'kknnDay'
        },
      ],
    }
  },
  props: {
  },
  computed: {
    kenkaku () {
      //return this.$store.state.summaries;
      return this.$store.state.gaiyoList;
    },
  },
  methods: {
    /**
     * 日付の和暦表示
     */
    dateTextToWareki(date) {
      return dateTextToWareki(date);  // from utils.js
    },   
    /**
     * 一覧でクリックされた行を選択
     * @param {GaiyoSummary} target 選択する概要データ
     */
    selectRow (target) {
      dbglog(`ListEstate.selectRow(${target.daichoId})`);
      this.$store.commit('setGaiyoId', target.daichoId);
      this.$store.commit('setKojiId', target.kojiId);
      this.$store.commit('setUkeDay', target.ukeDay);
      this.$store.commit('setUkeNo', target.ukeNo);
      this.kenkaku.forEach((k) => {
        k.active = (k === target);
      });
    },
  },
}
</script>
<style scoped src="@/styles/table-styles.css">
</style>